<script setup lang="ts">
import useTFAuthenticationSettingsStore from '@/stores/tf-authentication-settings';

const authSettingsStore = useTFAuthenticationSettingsStore();
</script>

<template>
  <div class="tw-text-center">
    <h2 class="tw-text-2xl tw-mb-8 tw-font-semibold">
      Scan the QR code below with your authenticator app
    </h2>

    <img
      class="tw-w-58 tw-h-58 tw-mx-auto"
      :src="authSettingsStore.getQRCodeImage"
    >
    <div class="tw-relative">
      <p
        class="tw-text-center tw-text-connx-primary tw-font-semibold tw-my-8 tw-mb-5"
      >
        Can't see the QR code?
      </p>
      <p>
        Manually enter your secret key:
        <strong class="tw-font-semibold">
          {{ authSettingsStore.getQRCodeNumber }}
        </strong>
      </p>
    </div>
  </div>
</template>
